import { Button, Grid, Group, Layout, Page } from "@/comn/components";
import { useFetch, useForm, useGrid, useModal, useResource, useStore, useToast, usePage } from "@/comn/hooks";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import {
    BASE,
    URLS,
    APIS,
    SF_TIN_SRCH,
    SF_TIN_TANCIS_INFO,
    SF_TIN_TAXPAYER_INFO,
} from "@/tra/tancis/ptli/crtr/tininfo/services/PtliTinInfoService";

/*
 * TIN Inforatmation Search
 * !== TIN 정보 조회 ==!
 */
export const PTLI0417001Q = (props: any) => {
    useResource({
        defaultSchema: [{ area: "cntyCd" }, { area: "comnCd", comnCd: "COM0033" }],
    });
    const [srchYn, setSrchYn] = useState("N");

    const { pgeUid, menuId } = usePage({
        auth: ["auth_ptli0015", "auth_ptli0044"],
    });

    const { t } = useTranslation();
    const navigate = useNavigate();
    const modal = useModal();
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid });
    const toast = useToast();

    const form = {
        tinSrch: useForm({
            defaultSchema: SF_TIN_SRCH,
            defaultValues: { ...pgeStore?.form },
        }),

        tinTancis: useForm({
            defaultSchema: SF_TIN_TANCIS_INFO,
        }),

        tinTaxpayer: useForm({
            defaultSchema: SF_TIN_TAXPAYER_INFO,
        }),
    };

    const fetch = {
        // Retrieve a list of region codes. !== 지역코드 목록을 조회한다.==!
        getTinInfo: useFetch({
            api: () => APIS.getTinInfo(form.tinSrch.getValues()),
            onSuccess: (data: any) => {
                // 데이터가 없을 경우
                if (!data.result.content.ptliTinInfoTancisDto && !data.result.content.ptliTinInfoTaxpayerDto) {
                    modal.openModal({ content: "msg.com.00034" }); // No data found. !== 해당 데이터가 없습니다. ==!

                    setSrchYn("N");

                    return;
                }

                if (!comnUtils.isEmpty(data.result.content.ptliTinInfoTancisDto)) {
                    form.tinTancis.setValues(data.result.content.ptliTinInfoTancisDto);
                } else {
                    form.tinTancis.clearValues();
                }
                if (!comnUtils.isEmpty(data.result.content.ptliTinInfoTaxpayerDto)) {
                    form.tinTaxpayer.setValues(data.result.content.ptliTinInfoTaxpayerDto);
                } else {
                    form.tinTaxpayer.clearValues();
                }

                setSrchYn("Y");
            },
            onError: () => toast.showToast({ type: "error", content: "msg.com.00018" }), // An error occurred. !== 에러가 발생했습니다! ==!
        }),

        updateTancisInfo: useFetch({
            api: (info: any) => APIS.updateTancisInfo(info),
            enabled: false,
            onSuccess: (data: any) => {
                modal.openModal({ content: "msg.com.00059" }); // Successfully updated. !== 정상적으로 수정되었습니다.==!

                fetch.getTinInfo.fetch();
            },
            onError: (error) => {
                const { errorCode, errorMessage } = error.response.data;

                if (errorCode === "-999") {
                    modal.openModal({ content: errorMessage }); // BizException
                } else {
                    toast.showToast({ type: "error", content: "msg.com.00022" }); // Failed to update. !== 수정이 실패하였습니다.==!
                }
            },
        }),
    };

    const handler = {
        onSrchBtnClick: () => {
            if (comnUtils.isEmpty(form.tinSrch.getValue("tin"))) {
                toast.showToast({ type: "warning", content: "msg.00002" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                return;
            }
            fetch.getTinInfo.fetch();
        },

        onAplyBtnClick: () => {
            modal.openModal({
                content: "msg.com.00050", // Confirm update? !== 수정하시겠습니까? ==!
                onConfirm: () => fetch.updateTancisInfo.fetch(form.tinTaxpayer.getValues()),
            });
        },
    };

    useEffect(() => {}, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.tinSrch.schema.tin} />
                            <Group.Control {...form.tinSrch.schema.bizYn} />
                        </Group.Row>
                    </Group.Section>
                    <Layout>
                        <Layout.Right>
                            <Button role={"search"} onClick={handler.onSrchBtnClick} />
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>
            <Group hidden={srchYn != "Y"}>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Label label={"L_TANCIS"} labelSize={6} align="center" />
                            <Group.Label label={"L_TAXPAYER"} labelSize={6} align="center" />
                        </Group.Row>

                        <Group.Row>
                            <Group.Control {...form.tinTancis.schema.name} />
                            <Group.Control {...form.tinTaxpayer.schema.name} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.tinTancis.schema.rprsTelno} />
                            <Group.Control {...form.tinTaxpayer.schema.rprsTelno} />
                        </Group.Row>

                        <Group.Row>
                            <Group.Control {...form.tinTancis.schema.scndTelno} />
                            <Group.Control {...form.tinTaxpayer.schema.scndTelno} />
                        </Group.Row>

                        <Group.Row>
                            <Group.Control {...form.tinTancis.schema.thrdTelno} />
                            <Group.Control {...form.tinTaxpayer.schema.thrdTelno} />
                        </Group.Row>

                        <Group.Row>
                            <Group.Control {...form.tinTancis.schema.rprsFaxNo} />
                            <Group.Control {...form.tinTaxpayer.schema.rprsFaxNo} />
                        </Group.Row>

                        <Group.Row>
                            <Group.Control {...form.tinTancis.schema.addr} />
                            <Group.Control {...form.tinTaxpayer.schema.addr} />
                        </Group.Row>

                        <Group.Row>
                            <Group.Control {...form.tinTancis.schema.tinTp} />
                            <Group.Control {...form.tinTaxpayer.schema.tinTp} />
                        </Group.Row>

                        <Group.Row>
                            <Group.Control {...form.tinTancis.schema.tinStat} />
                            <Group.Control {...form.tinTaxpayer.schema.tinStat} />
                        </Group.Row>
                    </Group.Section>
                </Group.Body>
            </Group>
            <Layout>
                <Layout.Right>
                    <Layout.Button
                        color="gray"
                        onClick={() => {
                            handler.onAplyBtnClick();
                        }}
                    >
                        {t("B_APPD")}
                    </Layout.Button>
                </Layout.Right>
            </Layout>
        </Page>
    );
};
